export const mutateUnfiToUnifi = (str: string): string => {
  return str.replace(/\bUNFI\b/g, "UNIFI");
};
